/**
 * FEIM API Game -> Operator messages
 */
export enum GameEvent {
    /* Internal events */
    LISTENING = "game-listening",
    HELLO = "game-hello",
    CONFIGURE = "configure",
    REALITY_CHECK_RESOLVED = "rc-resolved",
    PAUSED = "idle-paused",
    RESUMING_AFTER_PAUSE = "pause-resumed",
    REPORT_SESSION_DETAILS = "rc-session-details",
    /* Initiated by the game */
    GAME_LOAD_STARTED = "game-load-started",
    GAME_LOAD_PROGRESS = "game-load-progress",
    GAME_LOAD_COMPLETED = "game-load-loaded",
    ROUND_STARTED = "game-round-started",
    ROUND_FINISHED = "game-round-finished",
    FEATURE_STARTED = "feature-started",
    FEATURE_FINISHED = "feature-finished",
    REQUEST_VIEWPORT_CONFIG = "game-request-viewport-config", // Not used
    BALANCE_UPDATE = "balance-update",
    BET_UPDATE = "bet-update",
    WIN_UPDATE = "win-update",
    UPDATE_SETTINGS = "settings-changed",
    ERROR_MESSAGE = "error-message",
    EXIT_GAME = "exit-game",
    AUTOPLAY_STARTED = "autoplay-started",
    AUTOPLAY_FINISHED = "autoplay-finished",
    GOTO_GAME = "goto-game",
    OPEN_QUICK_DEPOSIT = "open-quick-deposit",
    USER_ACTION = "user-action",
}

/**
 * FEIM API Operator -> Game messages
 */
export enum OperatorEvent {
    LISTENING = "listening",
    HELLO = "hello",
    REFRESH_BALANCE = "update-balance",
    UPDATE_SETTINGS = "settings-update",
    PAYTABLE_TOGGLE = "toggle-paytable",
    ERROR_MESSAGE_DISMISSED = "error-message-dismissed",
    VIEWPORT_UPDATE = "viewport-update", // Not used
    ERROR_MESSAGE_DISPLAYED = "error-message-displayed",
    EXITING_GAME = "exiting-game",
    LOCK_PLAY = "lock-play",
    UNLOCK_PLAY = "unlock-play",
    PAUSE_AUTOPLAY = "pause-autoplay",
    TOGGLE_GAME_HELP = "toggle-game-help",
    FREEZE = "freeze",
    UNFREEZE =  "unfreeze",
    // For P2P only, when FEIM can't send rcchoice
    P2P_RC_CHOICE = "rc-choice",
    // Internal, will not reach the game. Once a round is not running will dispatch FREEZE instead, and open the RC popup if realityCheck is true
    _PAUSE_WHEN_IDLE = "pause-when-idle",
    _RESUME = "pause-resume",
    // Internal, will not reach game
    _SEND_RCCHOICE = "reality-check-choice",
    _NAVIGATE_GAME = "navigate-game",
}

export interface IFeimHelloData {
    readonly feimVersion: string;
}

export interface ITheosHelloData {
    readonly handlesErrors: boolean;
    readonly handlesExit: boolean;
}

export interface IConfigData {
    readonly currencyCode?: string;
    readonly handleFeaturePause?: boolean;
}

export interface INavigateGameData {
    readonly url: string;
}

export interface IRealityCheckInput {
    readonly action?: "stop" | "continue";
}